export enum NotificationType {
  EMAIL = "EMAIL",
  SMS = "SMS",
  WEB = "WEB",
  CONTINUE = "continue",
}
